import { TUPLE, isTimerSelection, unitName } from '.';
export var TOGGLE = '_toggle';
var toggle = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'point' && !isTimerSelection(selCmpt) && !!selCmpt.toggle;
  },
  signals: function signals(model, selCmpt, _signals) {
    return _signals.concat({
      name: selCmpt.name + TOGGLE,
      value: false,
      on: [{
        events: selCmpt.events,
        update: selCmpt.toggle
      }]
    });
  },
  modifyExpr: function modifyExpr(model, selCmpt) {
    var tpl = selCmpt.name + TUPLE;
    var signal = selCmpt.name + TOGGLE;
    return "".concat(signal, " ? null : ").concat(tpl, ", ") + (selCmpt.resolve === 'global' ? "".concat(signal, " ? null : true, ") : "".concat(signal, " ? null : {unit: ").concat(unitName(model), "}, ")) + "".concat(signal, " ? ").concat(tpl, " : null");
  }
};
export default toggle;